// Core
import { connect } from 'react-redux';
// Actions
import { setSelection } from '../../../../ducks/withShop/Methods';

import Component from './Component';

const mapStateToProps = state => ({
    selection: state.withShop.q1.selection,
});

const mapDispatchToProps = {
    setSelection,
};

const Q1 = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Q1;